export class APIError extends Error {
  statusCode: number;

  info: string | Record<string, string>;

  constructor(
    message: string | object,
    statusCode: number,
    info: string | Record<string, string>,
  ) {
    const errorMessage =
      typeof message === "string" ? message : JSON.stringify(message);
    super(errorMessage);

    this.name = this.constructor.name;
    this.statusCode = statusCode;
    this.info = info;
  }
}
